var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-info"},[_c('div',{staticClass:"payment-info__wrap"},[_c('div',{staticClass:"payment-info__title"},[_vm._v(_vm._s(_vm.$t("succesFastBuyCreate")))]),_c('div',{staticClass:"payment-info__description",domProps:{"innerHTML":_vm._s(_vm.getText())}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }